import { useEffect, useState } from "react";
import api from "../lib/api";
import { StatCard } from "../components/StatCard";
import { PageHeader, DataTable, Pill } from "../components/Table";
import { Package, CheckCircle, ArrowsClockwise, Wallet } from "@phosphor-icons/react";

export default function Dealers() {
  const [data, setData] = useState(null);
  const [dealers, setDealers] = useState([]);
  useEffect(() => {
    api.get("/dealers/dashboard").then((r) => setData(r.data));
    api.get("/dealers").then((r) => setDealers(r.data.dealers));
  }, []);
  if (!data) return <div className="p-5 text-muted-foreground">Loading…</div>;

  const columns = [
    { key: "name", header: "Dealer", render: (r) => <span className="font-semibold">{r.name}</span> },
    { key: "city", header: "City" },
    { key: "state", header: "State" },
    { key: "stock_count", header: "Stock" },
    { key: "installed_count", header: "Installed" },
    { key: "wallet_balance", header: "Wallet", render: (r) => <span className="font-mono">₹{r.wallet_balance.toLocaleString()}</span> },
  ];

  const insCols = [
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-semibold">{r.vehicle_number}</span> },
    { key: "imei", header: "IMEI", render: (r) => <span className="font-mono text-xs">{r.imei}</span> },
    { key: "status", header: "Status", render: (r) => <Pill color={r.status.includes("ACTIVATED") ? "#34C759" : "#FF9500"}>{r.status}</Pill> },
  ];

  return (
    <div className="p-5 space-y-5">
      <PageHeader title="Dealer Portal" subtitle={data.dealer?.name} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testid="dealer-stock" label="My Stock" value={data.stats.stock} icon={Package} accent="#5AC8FA" />
        <StatCard testid="dealer-installed" label="Installed" value={data.stats.installed} icon={CheckCircle} accent="#34C759" />
        <StatCard testid="dealer-expiring" label="Expiring" value={data.stats.expiring} icon={ArrowsClockwise} accent="#FF9500" />
        <StatCard testid="dealer-wallet" label="Wallet" value={`₹${(data.stats.wallet || 0).toLocaleString()}`} icon={Wallet} accent="#fff" />
      </div>

      <div>
        <div className="label-caps mb-2">Recent Installations</div>
        <DataTable testid="dealer-installs" columns={insCols} rows={data.recent_installations} />
      </div>

      <div>
        <div className="label-caps mb-2">All Dealers & Distributors</div>
        <DataTable testid="dealers-table" columns={columns} rows={dealers} />
      </div>
    </div>
  );
}
